import React, { useEffect, useState } from "react";
import PageTitle from "../../../module/pageTitle";
import AdminTable from "../../../Component/adminTable";
import LabelInput from "../../../Component/labelInput";
import { InputField, Submitbtn } from "../../../Component";
import { getDepartmentList } from "../superAdminSlice";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../../store";
import { updateDepartment, deleteDepartment } from "../superAdminSlice";
import { validateIsLettersAndDigitsSpaceOnly } from "../../../Utils/validators";
import { showSnackbar, hideSnackbar } from '../../../store/slices/snackbarSlice';
const EditDeleteDepartment = () => {
  const dispatch: Function = useDispatch<AppDispatch>();
  const [isEdit, setIsEdit] = useState<Boolean>(false);
  const [departmentList, setDepartmentList] = useState<any>([]);
  const [departmentName, setDepartmentName] = useState<string>("");
  const [departmentID, setDepartmentID] = useState<string>("");
  const [depStatus, setDepStatus] = useState<string>("");
  useEffect(() => {
    getData()
  }, []);

  const getData = () => {
    dispatch(
      getDepartmentList({
        callback: (res: any) => {
          setDepartmentList(res?.data);
        },
        errorCallback: () => { },
      })
    );
  };

  const handleEdit = (value: any) => {
    setIsEdit(true);
    setDepartmentName(value?.name);
    setDepartmentID(value?._id);
    setDepStatus(value?.status);
  };

  const onChangeDepartment = (value: string) => {
    if (validateIsLettersAndDigitsSpaceOnly(value)) {
      setDepartmentName(value);
    }
  };

  const handleSubmit = (e: { preventDefault: () => void }) => {
    e.preventDefault();
    const Payload = {
      name: departmentName,
      // status: depStatus
    };
    dispatch(
      updateDepartment({
        id: departmentID,
        params: Payload,
        callback: (res: any) => {
          setIsEdit(false);
          getData()
          dispatch(showSnackbar({ message: res?.msg, type: res?.status }));
          setTimeout(() => {
            dispatch(hideSnackbar());
          }, 5000);
        },
        errorCallback: () => {
          dispatch(showSnackbar({ message: "Something went wrong", type: "error" }));
          setTimeout(() => {
            dispatch(hideSnackbar());
          }, 5000);

        },
      })
    );
    setIsEdit(false);
  };

  const handleDelete = (value: any) => {
    dispatch(
      deleteDepartment({
        id: value?._id,
        callback: (res: any) => {
          setIsEdit(false);
          getData()
        },
        errorCallback: () => { },
      })
    );
  };

  const renderTable = () => {
    return (
      <AdminTable
        tableData={departmentList ? departmentList : []}
        pagename={"DepartmentList"}
        tableHead={["S.N", "Name", "Action"]}
        handleEdit={(value: any) => handleEdit(value)}
        handleDelete={(value: any) => handleDelete(value)}
        edit={true}
      />
    );
  };

  const renderEditMode = () => {
    return (
      <form onSubmit={handleSubmit}>
        <div className="row align-items-center">
          <div className="col-md-6">
            <LabelInput labelName={"Department Name"} />
            <div className="d-flex align-items-center my-3">
              <div className="me-3 col-md-8">
                <InputField
                  key={"ex2"}
                  placeholder={"Enter Department Name"}
                  setInputText={(value: any) => onChangeDepartment(value)}
                  value={departmentName}
                />
              </div>
              <div className="col-md-2">
                <Submitbtn name={"Edit"} disabled={!departmentName} />
              </div>
            </div>
          </div>
        </div>
      </form>
    );
  };
  const handleGoBack = () => {
    setIsEdit(false);
  };
  return (
    <div className="panel-content">
      <div className="mb-4">
        <PageTitle
          name={"Edit / Delete DepartMent"}
          breadCrumb={""}
          isEditMode={isEdit}
          setisEditMode={setIsEdit}
          cancelEdit={() => handleGoBack()}
        />
      </div>
      <div className="formDiv">
        <div className="bxshadow p-2 borderRadius">
          {isEdit ? renderEditMode() : renderTable()}
        </div>
      </div>
    </div>
  );
};

export default EditDeleteDepartment;
